import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_CHILD_ACCOUNTS: "FETCH_CHILD_ACCOUNTS",
};

const fetch = async (state, childaccounts) => {
  state = {
    ...state,
    isStatus: childaccounts.status,
    expireToken: sanitizeExpire({
      status: childaccounts.status,
      data: childaccounts.data,
      name: "childaccountsobj",
    }),
    data: sanitizeData({
      status: childaccounts.status,
      data: childaccounts.data,
      name: "childaccountsobj",
    }),
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHILD_ACCOUNTS:
      return fetch(state, action.childaccounts);
    default:
      return state;
  }
};

const index = {
  init,
  actionTypes,
  reducer,
};

export default index;
